import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/** Steps of the website settings page, in display order. */
export const WEBSITE_SETTINGS_STEPS = [
  'design',
  'brand',
  'contact',
  'content',
  'address',
] as const;

/** One step of the website settings page. */
export type WebsiteSettingsStep = (typeof WEBSITE_SETTINGS_STEPS)[number];

/** Translation keys of the step names. */
export const WEBSITE_SETTINGS_STEP_LABEL_KEYS: Record<
  WebsiteSettingsStep,
  TranslationKey
> = {
  design: 'websites.settings.steps.design',
  brand: 'websites.settings.steps.brand',
  contact: 'websites.settings.steps.contact',
  content: 'websites.settings.steps.content',
  address: 'websites.settings.steps.address',
};
